<template>
  <div>
    <b-table-simple bordered responsive hover class="kl-groups-table">
      <b-thead>
        <b-tr>
          <b-th v-if="selected_mode">
            {{ $t("reusable.common.select") }}
          </b-th>
          <b-th style="width: 20%">
            <div>{{ $t("evaluations.newEvaluations.groupName") }}</div>
          </b-th>
          <b-th style="width: 40%">
            <div>{{ $t("evaluations.newEvaluations.groupLeader") }}</div>
          </b-th>
          <b-th style="width: 40%">
            <div>{{ $t("evaluations.newEvaluations.groupMembers") }}</div>
          </b-th>
          <b-th v-if="allows_crud && newTestGroups.length > 0"> </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-if="newTestGroups.length > 0">
          <b-tr v-for="group in newTestGroups" :key="group.id + 'group'">
            <b-td v-if="selected_mode" class="text-center">
              <b-form-checkbox
                v-model="group.selected"
                @input="slotGroupsSelectionChanged"
                :disabled="
                  group.students.every((x) => usersNoAvailable.includes(x))
                "
              >
                <!-- :disabled="!isNaN(egress_profile_id)" -->
              </b-form-checkbox>
            </b-td>
            <b-td>
              <div class="text-left">{{ group.name }}</div>
            </b-td>
            <b-td>
              <div class="text-left">
                <span
                  :class="{
                    'unavialable-student': usersNoAvailable.includes(
                      group.leader
                    ),
                  }"
                  v-b-tooltip.v-secondary.noninteractive.hover.top="
                    usersNoAvailable.includes(group.leader)
                      ? $t('evaluations.newEvaluations.studentInGroupName', {
                          groupName: groupName(group.leader),
                        })
                      : ''
                  "
                >
                  {{ getUserName(group.leader) }}
                </span>
              </div>
            </b-td>
            <b-td>
              <div
                class="text-left"
                v-for="(group_student, index) in group.students"
                :key="index"
              >
                <!--vfor con los nombres de los estudiantes -->
                <span
                  :class="{
                    'unavialable-student':
                      usersNoAvailable.includes(group_student),
                  }"
                  v-b-tooltip.v-secondary.noninteractive.hover.top="
                    usersNoAvailable.includes(group_student)
                      ? $t('evaluations.newEvaluations.studentInGroupName', {
                          groupName: groupName(group_student),
                        })
                      : ''
                  "
                >
                  {{ getUserName(group_student) }}
                </span>
              </div>
            </b-td>
            <b-td v-if="allows_crud" class="container-btn-group">
              <div class="container-btn-group-div">
                <b-button
                  variant="primary"
                  size="sm"
                  class="edit-btn p-1 mb-1"
                  v-if="allows_crud && Test.allow_group_creation"
                  v-b-tooltip.top.noninteractive.v-secondary="
                    $t('evaluations.newEvaluations.editGroup')
                  "
                  tabindex="-1"
                  @click="
                    $bvModal.show(
                      `modal-edit-group-${Test.id}-${container_instrument_id}-${group.id}`
                    )
                  "
                >
                  <b-icon-pencil-square></b-icon-pencil-square>
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  class="delete-btn p-1"
                  v-if="allows_crud"
                  tabindex="-1"
                  v-b-tooltip.top.noninteractive.v-secondary="
                    $t('evaluations.newEvaluations.deleteGroup')
                  "
                  @click="askForDeleteGroup(group.id)"
                >
                  <b-icon-trash></b-icon-trash>
                </b-button>
              </div>
            </b-td>
            <b-modal
              :id="`modal-edit-group-${Test.id}-${container_instrument_id}-${group.id}`"
              :title="$t('evaluations.newEvaluations.editGroup')"
              size="lg"
              hide-footer
            >
              <GroupsForm
                :Test="Test"
                :StudentGroup="group"
                @updated="
                  $bvModal.hide(
                    `modal-edit-group-${Test.id}-${container_instrument_id}-${group.id}`
                  )
                "
                @deleted="
                  $bvModal.hide(
                    `modal-edit-group-${Test.id}-${container_instrument_id}-${group.id}`
                  )
                "
              ></GroupsForm>
            </b-modal>
          </b-tr>
        </template>
        <template v-else-if="newTestGroups.length == 0">
          <b-tr>
            <b-td colspan="3">
              <div>{{ $t("evaluations.newEvaluations.noGroupsEntered") }}</div>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "../../../../utils/utils";

export default {
  name: "GroupsTable",
  components: {
    GroupsForm: () => import("./GroupsForm"),
  },
  props: {
    Test: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    container_instrument_id: {
      type: String,
    },
    selected_mode: {
      default: false,
    },
    usersNoAvailable: {
      type: Array,
      default: () => [],
    },
    evaluatee_view: {
      type: Boolean,
      default: false,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: Number,
      required: false,
    },
    //Este el el id del test del contenedor para indicar el grupo al cual pertenece el estudiante.
    id_test_container: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      users: names.USERS,
      new_tests: names.NEW_TESTS,
      new_test_groups: names.NEW_TEST_GROUPS,
    }),
    newTestGroups() {
      if ((this.evaluatee_view || this.evaluator_view) && this.user_id) {
        return this.new_test_groups.filter(
          (x) => x.test == this.Test.id && x.students.includes(this.user_id)
        );
      } else
        return this.new_test_groups
          .filter((x) => x.test == this.Test.id)
          .map((x) => ({ ...x, selected: false }));
    },
  },
  methods: {
    groupName(student_id) {
      if (!this.id_test_container) return "";
      const group_name = this.new_test_groups.find(
        (x) =>
          x.test == this.id_test_container && x.students.includes(student_id)
      );
      return group_name ? group_name.name : "";
    },
    getUserName(user_id) {
      const user = this.users.find((x) => x.id == user_id);
      if (user) {
        if (user.user_data)
          return (
            user.user_data.identifier +
            " " +
            user.first_name +
            " " +
            user.last_name
          );
        else return user.first_name + " " + user.last_name;
      } else return null;
    },
    askForDeleteGroup(group_id) {
      this.$swal({
        title: `<p>${this.$t(
          "evaluations.newEvaluations.sureToDeleteTheGroup"
        )}</p>`,
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_NEW_TEST_GROUP, group_id);
          toast(
            this.$t("evaluations.newEvaluations.entityDeleted", {
              entity: this.$getVisibleNames(
                "evaluations2.testdescriptor",
                false,
                "Descriptor"
              ),
            })
          );
        }
      });
    },
    slotGroupsSelectionChanged() {
      this.$emit(
        "update_checks",
        this.newTestGroups.filter((x) => x.selected)
      );
    },
  },
  created() {},
};
</script>

<style scoped>
/* Tabla de grupos migrada al estándar styles_kl.css (design tokens --kl-*). */
.kl-groups-table {
  color: var(--kl-table-text);
}
.kl-groups-table >>> th,
.kl-groups-table >>> td {
  border-color: var(--kl-table-border) !important;
  vertical-align: middle;
}
.kl-groups-table >>> thead th {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-weight: var(--kl-fw-bold);
  border-color: var(--kl-table-border) !important;
}
.unavialable-student {
  text-decoration: line-through !important;
  color: var(--kl-text-muted);
}
.container-btn-group {
  vertical-align: middle;
}
.container-btn-group-div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.select-form {
  min-width: 270px;
  font-size: var(--secondary-font-size);
  margin: 3px;
}
.delete-btn {
  border: 1px;
  max-height: 27px;
  width: 27px;
}
.delete-btn:hover {
  background-color: #e45d6b;
}
.edit-btn:hover {
  background-color: var(--kl-primary-button-hover-color);
}
.edit-btn {
  border: 1px;
  max-height: 27px;
  width: 27px;
}
</style>

